import { Component, OnInit } from '@angular/core';
import { ToggleThemeService } from 'src/app/data-services/toggle-theme.service';


@Component({
  selector: 'app-toggle-theme',
  templateUrl: './toggle-theme.component.html',
  styleUrls: ['./toggle-theme.component.css']
})
export class ToggleThemeComponent {
  currentTheme: string | null = "";

  constructor(private themeService: ToggleThemeService) {
    const storedTheme = localStorage.getItem("Theme");
    this.currentTheme = storedTheme ? storedTheme : 'dark';
    document.documentElement.setAttribute('data-theme', this.currentTheme);
  }

  toggleTheme() {
    this.currentTheme = document.documentElement.getAttribute('data-theme');
    const newTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
    this.themeService.setCurrentTheme(newTheme);
    this.currentTheme = newTheme;
    localStorage.setItem("Theme", newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  }
}